import axios from "axios";
import { toast } from "react-toastify";

export const staffClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || "https://rest.ywenf.com",
    withCredentials: true,
});

staffClient.interceptors.response.use(
    response => {
        return response;
    },
    responseErrorInterceptor
);

export async function responseErrorInterceptor(error) {
    console.log("[staffClient] response error", error);
    if (error.response.status === 401) {
        return handleUnauthorized(error);
    }
    if(error.response.status === 403) {
        return handleForbidden(error);
    }
    return Promise.reject(error);
}

const handleUnauthorized = async (error) => {
    console.log("[401 error]", error);
    window.location.replace("/login");
    return Promise.reject(error);
}

const handleForbidden = async (error) => {
    toast.error("권한이 없습니다.");
}